import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterActive'
})
export class FilterActivePipe implements PipeTransform {
  transform(items: any[]): any[] {
    if (!items) return [];
    return items.filter(item => item.active);
  }
}
